import { Header, Tabs, Grid, Title, Burger, Group } from "@mantine/core";
import { useEffect, useRef } from "react";
import { useMediaQuery } from '@mantine/hooks';

const AppHeader = (props) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const isLarge = useMediaQuery('(min-width: 992px)');

  const headerRef = useRef(null);

  useEffect(() => {
    if (!props.setHeaderHeight) return;
    const update = () => {
      if (!headerRef.current) {
        props.setHeaderHeight(0);
        return;
      }
      const rect = headerRef.current.getBoundingClientRect();
      const h = Math.ceil(rect.height) + 20; // add small buffer to avoid 1-3px overlap (+10px requested)
      props.setHeaderHeight(h);
    };

    update();
    const ro = new ResizeObserver(update);
    if (headerRef.current) ro.observe(headerRef.current);
    window.addEventListener('resize', update);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', update);
    };
  }, [props.setHeaderHeight]);

    const navbarWidth = isMobile ? 0 : (isLarge ? 250 + 16 : 200 + 16);

    return (
    <Header p="md">
      <div ref={headerRef} style={{ marginLeft: props.opened ? navbarWidth : 0 }}>
        <Grid>
          <Grid.Col span={4}>
            <Group align="center">
              {isMobile && (
                <Burger opened={props.opened} onClick={() => props.setOpened && props.setOpened(!props.opened)} size="sm" style={{ zIndex: 1001 }} />
              )}
              <Title order={1}>Scouting 2026</Title>
            </Group>
          </Grid.Col>
          <Grid.Col span={8}>
            <Tabs value={props.event || props.defaultValue} variant="pills" onTabChange={props.setEvent}>
              <Tabs.List position="right">
                <Tabs.Tab value="2026cacc">Capital City Classic 2026</Tabs.Tab>
                <Tabs.Tab value="2026cacg">CalGames 2026</Tabs.Tab>
                <Tabs.Tab value="2026joh">Worlds Johnson Division 2026</Tabs.Tab>
                <Tabs.Tab value="2026cancmp">NorCal District Championship 2026</Tabs.Tab>
              </Tabs.List>
            </Tabs>
          </Grid.Col>
        </Grid>
      </div>
    </Header>
  )
}

export default AppHeader;